'use client';
import { NextPage } from 'next';
import { useForm } from 'react-hook-form';
import { Checkbox } from './CheckBox';
import Button from './Button';
import { useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';
import useOnboardingFormStore from '../../dashboard/stores/useOnboardingFormStore';
import { OnboardingFormComponentProps, UserAttributesType, roles } from '../utils/types';

export const initialRolesData = roles.reduce((acc, rec) => {
    return { ...acc, [rec.title]: false }
},{});

const Roles: NextPage<OnboardingFormComponentProps> = ({ currentStep, setCurrentStep, submitedForms, setSubmitedForms }) => {
    const [steps, setCurrentStepToStore, updateUserRolesAndGoalsData, userOnboarding, optimizeSteps, setCurrentOptimizeStepToStore] = useOnboardingFormStore((state) => [state.steps, state.setCurrentStepToStore, state.updateUserRolesAndGoalsData, state.user, state.optimizeSteps, state.setCurrentOptimizeStepToStore], shallow);

    const {
        register,
        watch,
        handleSubmit,
        getValues,
        formState: { errors },
    } = useForm<{[key: string]: boolean}>({ defaultValues: optimizeSteps[currentStep] ? optimizeSteps[currentStep].data : {} });

    const formValues = Object.values(getValues()).length !== 0;

    const [values, setValues] = useState<boolean[]>((formValues && Object.values(getValues()).filter((value) => value)) || []);

    useEffect(() => {
        const subscription = watch((value) => setValues(Object.values(value).filter((value) => value) as boolean[]));
        return () => subscription.unsubscribe();
    }, [watch]);

    const onSubmit = (data: any) => {
        if (!submitedForms.includes(currentStep)) {
            setSubmitedForms([...submitedForms, currentStep]);
        }
        setCurrentOptimizeStepToStore({ id: currentStep, data, isSubmited: true })
        setCurrentStep(currentStep + 1);
        updateUserRolesAndGoalsData({ type: UserAttributesType.ROLES, data })
    };

    return (
        <form className="flex flex-col gap-4" onSubmit={handleSubmit(onSubmit)}>
            <h1 className="text-kartiv-gray-900 text-2xl font-semibold">
                What do you do? <br /> Choose one or more.
            </h1>
            <div className="w-full grid gap-4 grid-cols-2">
                {roles.map((role) => {
                    return (
                        <div key={role.title}>
                            <Checkbox register={register} name={role.title} icon={role.icon} />
                        </div>
                    );
                })}
            </div>
            <div className="pt-4">
                <Button disabled={!values || values.length < 1} label="Next" type="submit" isArrow />
            </div>
        </form>
    );
};

export default Roles;
